import { ApiConfig } from "common/models";
import { buildGdxApiUrl } from "common/utils/api.util";

export const chatbotConfig = {
  // Fetch flow configurations filtered by document type
  fetchFlowsByDocumentType: (documentType: string): ApiConfig => {
    const encodedDocumentType = encodeURIComponent(documentType.trim());
    return new ApiConfig(
      buildGdxApiUrl(
        `gdx/database/document_type_information/get/${encodedDocumentType}`
      ),
      "GET",
      encodedDocumentType,
      undefined
    );
  },

  // Fetch documents by flow ID (paginated)
  fetchDocumentsByFlow: (
    flowId: number | string,
    page?: number,
    pageSize?: number
  ): ApiConfig => {
    const resolvedPage = page ?? 1;
    const resolvedPageSize = pageSize ?? 100;
    const payload = {
      page: resolvedPage,
      size: resolvedPageSize,
      sort: "",
      dir: "",
      search: "",
      showDuplicates: false,
      flow_id: flowId
    };

    return new ApiConfig(
      buildGdxApiUrl(`gdx/database/document-master/get-all`),
      "POST",
      "",
      payload
    );
  }
};
